import { render, staticRenderFns } from "./SvgSprite.vue?vue&type=template&id=6daa5ca9&"
import script from "./SvgSprite.vue?vue&type=script&lang=ts&"
export * from "./SvgSprite.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports